import { resetItemsDisplayOrder } from '../util';
import FieldInstance from "./FieldInstance";

class FieldBlock {
  constructor() {
    const data = arguments[0] || {};
    this.id = data.id || null;
    this.items = data.items || [];
    this.logic_groups = data.logic_groups || [];
    this.display_order = data.display_order || 0;
    this.location_variables = data.location_variables || [];
    this.role_variables = data.role_variables || [];
    this.locations = data.locations || [];
  }

  insertItem(item, index) {
    if (!(item instanceof FieldInstance)) {
      return false;
    }
    this.items.splice(index, 0, item);
    resetItemsDisplayOrder(this.items);
  }

  addLogicGroup(logicGroup) {
    this.logic_groups.push(logicGroup);
  }

  removeLogicGroup(logicGroup) {
    let idx = this.logic_groups.indexOf(logicGroup);
    if (idx !== -1) {
      this.logic_groups.splice(idx, 1);
      return 1;
    }
    return 0;
  }

  get hasLocationVariables() {
    return this.location_variables.length > 0;
  }

  get hasRoleVariables() {
    return this.role_variables.length > 0;
  }

  get hasLocations() {
    return this.locations.length > 0;
  }

  removeAllLocationVariables() {
    this.location_variables.length = 0;
  }

  removeAllRoleVariables() {
    this.role_variables.length = 0;
  }

  removeAllLocations() {
    this.locations.length = 0;
  }

  get isFieldInstance() {
    return false;
  }

  get isFieldBlock() {
    return true;
  }

  get isForm() {
    return false;
  }
}

export default FieldBlock;
